import { render, staticRenderFns } from "./ConstituteDisc.vue?vue&type=template&id=00331c95&scoped=true"
import script from "./ConstituteDisc.vue?vue&type=script&lang=js"
export * from "./ConstituteDisc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00331c95",
  null
  
)

export default component.exports